export default {
  KICH_TAI_LOC: 38,
  NHA_O: 21
}




// WEBPACK FOOTER //
// ./src/communicate/DichVuType.js